import React from "react";
import { Loader2, RefreshCw } from "lucide-react";
import UserSurfacePager from "./UserSurfacePager.jsx";
import { UserSurfaceRowSkeleton } from "./UserSurfaceRow.jsx";

function SummaryChips({ parts }) {
  if (!parts?.length) return null;
  return (
    <div className="au-surface-summary-chips" aria-label="Status breakdown">
      {parts.map((part) => (
        <span key={part} className="au-surface-summary-chip">
          {part}
        </span>
      ))}
    </div>
  );
}

export default function UserActivitySurface({
  title,
  total,
  totalLabel = "items",
  summaryParts = [],
  itemCount = 0,
  loading,
  error,
  onRefresh,
  onRetry,
  emptyMessage,
  children,
  pager,
}) {
  const count = total ?? 0;
  const hasItems = itemCount > 0;

  return (
    <section className="au-surface-panel" aria-label={title || "Member activity"}>
      <header className="au-surface-panel-head">
        <div className="au-surface-panel-lead">
          <h3 className="au-surface-panel-title">{title}</h3>
          <p className="au-surface-panel-meta">
            <strong>{count}</strong> {count === 1 ? totalLabel.replace(/s$/, "") : totalLabel}
          </p>
          <SummaryChips parts={summaryParts} />
        </div>
        <button
          type="button"
          className="au-surface-panel-refresh"
          onClick={onRefresh}
          disabled={loading}
          aria-label={`Refresh ${title || "list"}`}
        >
          <RefreshCw size={14} className={loading ? "au-spin" : ""} aria-hidden />
        </button>
      </header>

      {error ? (
        <div className="au-surface-panel-error" role="alert">
          <span>{error}</span>
          <button type="button" onClick={onRetry}>
            Retry
          </button>
        </div>
      ) : null}

      <div className="au-surface-list">
        {loading && !hasItems ? (
          Array.from({ length: 4 }).map((_, i) => <UserSurfaceRowSkeleton key={i} />)
        ) : !hasItems && !loading ? (
          <p className="au-detail-tab-empty">{emptyMessage}</p>
        ) : (
          children
        )}
      </div>

      {pager ? <UserSurfacePager {...pager} /> : null}

      {loading && hasItems ? (
        <div className="au-surface-panel-loading" aria-live="polite">
          <Loader2 size={14} className="au-spin" aria-hidden />
          <span>Updating…</span>
        </div>
      ) : null}
    </section>
  );
}
